export default {"src":"https://assets.madeeasy.in/prod/_next/static/media/dropdown-arrow.63c27bf2.svg","height":19,"width":22,"blurWidth":0,"blurHeight":0};